import React, { Component } from 'react';
import styles from './Autocomplete.scss';

export default class Autocomplete extends Component {
  static defaultProps = {
    items: [],
    filter: (item, query) => item.name.toLowerCase().includes(query.toLowerCase()),
    sort: () => {},
  };

  constructor(props) {
    super(props);

    this.state = {
      open: false,
      highlighted: -1,
    };


    this.input = React.createRef();
    this.menuEl = React.createRef();
    this.wrapperRef = React.createRef();
    this.setWrapperRef = this.setWrapperRef.bind(this);
    this.handleClickOutside = this.handleClickOutside.bind(this);
  }

  componentWillReceiveProps(nextProps) {
    const { input } = this.refs;
    if (input.value !== nextProps.defValue) {
      input.value = nextProps.defValue ? nextProps.defValue : '';
    }
  }

  componentDidMount() {
    document.addEventListener('mousedown', this.handleClickOutside);
  }

  componentWillUnmount() {
    document.removeEventListener('mousedown', this.handleClickOutside);
  }

  setWrapperRef(node) {
    this.wrapperRef = node;
  }

  handleClickOutside(event) {
    if (this.wrapperRef && !this.wrapperRef.contains(event.target)) {
      this.close();
    }
  }

  items = () => {
    const {
      items, filter, sort, limit,
    } = this.props;
    const { value = '' } = this.refs.input || {};

    return items
      .filter(item => filter(item, value))
      .sort(sort)
      .slice(0, limit);
  };

  children = () => {
    return <input type="text" className={styles.input} placeholder={this.props.placeholder || ''} />;
  };

  renderMenu = ({ items }) => {
    return <ul className={styles.menu} ref={this.menuEl}>{items}</ul>;
  };

  renderItem = ({ item, highlighted }) => {
    const r =
      highlighted
        ? <li className={['selected', styles.selected].join(' ')}><span>{item.name}</span></li>
        : <li><span>{item.name}</span></li>;

    return r;
  };

  open = () => {
    this.setState({ open: true });
  };

  close = () => {
    this.setState({ open: false });
  };

  // menu
  handleMouseLeave = (_event) => {
    this.setState({ highlighted: -1 });
  };

  // item
  handleMouseEnter = index => (_event) => {
    this.setState({ highlighted: index });
  };

  // item
  handleMouseDown = () => {
    const { input } = this.refs;
    input.focus();
  };

  // item
  handleSelectItem = item => (event) => {
    const { onChoose } = this.props;
    const { input } = this.refs;

    /**
     * If there is no onChoose, just update the value
     */
    input.value = item.name;

    /**
     * After updating the value, we need to trigger an onChange event.
     * Can also trigger by returning true in onChoose
     */
    if (onChoose) {
      onChoose(item, event);
      const changeEvent = new Event('input', { bubbles: true });
      input.dispatchEvent(changeEvent);
    }

    /**
     * Close the menu and allow blur events
     * to continue,
     */

    setTimeout(() => {
      this.close();
      input.blur();
    }, 100);
  };

  // children
  handleFocus = (event) => {
    const { onFocus } = this.props;


    this.setState({ focused: true });

    this.open();
    onFocus && onFocus(event);
  };

  // children
  handleBlur = (event) => {
    const { onBlur } = this.props;
    const { input } = this.refs;


    if (this.state.focused) return;

    this.setState({ focused: false });
    input.blur();
    this.close();
    onBlur && onBlur(event);
  };

  // children
  handleKeyDown = (event) => {
    const { highlighted } = this.state;

    const selectedEl = this.menuEl.current.getElementsByClassName('selected')[0];

    this.open();

    switch (event.key) {
      case 'ArrowDown':
        event.preventDefault();
        selectedEl && selectedEl.scrollIntoView({ inline: 'end' });
        const next = Math.min(highlighted + 1, this.items().length - 1);
        this.setState({ highlighted: next });
        return;

      case 'ArrowUp':
        event.preventDefault();
        selectedEl && selectedEl.scrollIntoView({ inline: 'end' });
        const prev = Math.max(highlighted - 1, -1);
        this.setState({ highlighted: prev });
        return;

      case 'Enter':
        event.preventDefault();
        if (highlighted > -1) {
          this.handleSelectItem(this.items()[highlighted])(event);
        }
        return;

      case 'Escape':
        this.close();
        return;

      case 'Tab':
        this.close();
        return;

      default:
        // TODO: Add debounce
        setTimeout(() => this.forceUpdate());
    }
  };

  render() {
    const {
      children,
      items,
      filter,
      sort,
      width,
      ...props
    } = this.props;

    const renderedItems = this.items().map((item, index) => {
      const highlighted = this.state.highlighted === index;
      return React.cloneElement(this.renderItem({ item, index, highlighted }), {
        onMouseEnter: this.handleMouseEnter(index),
        onMouseDown: this.handleMouseDown,
        onClick: this.handleSelectItem(item),
        key: `${index}${item.name.substr(0, 3)}`,
      });
    });

    const renderedMenu = React.cloneElement(this.renderMenu({ items: renderedItems }), {
      onMouseLeave: this.handleMouseLeave,
    });

    return (
      <div className={styles.inputHolder} style={{ width: width || 200 }} ref={this.setWrapperRef}>
        {React.cloneElement(this.children(), {
          onKeyDown: this.handleKeyDown,
          onFocus: this.handleFocus,
          onBlur: this.handleBlur,
          ref: 'input',
        })}

        {this.state.open && renderedMenu}
      </div>
    );
  }
}
